import Common from './modules/common.js';
import News from './modules/news.js';
import ServiceCompaniesTicker from './modules/service-companies-ticker.js';
import TopKv from './modules/top-kv.js';

class App {
	constructor() {
		this.bodyTag = document.querySelector('body');

		this.routes();
  }

	routes() {
    this.common = new Common();

		if(this.bodyTag.classList.contains('p-index')) {
			this.news = new News();
			this.topKv = new TopKv();
			this.serviceCompaniesTicker = new ServiceCompaniesTicker();
		}
	}
}

window.App = new App();